import type { PayPeriod, PaymentFormValues, PaymentType } from '../types/payment';
import {
  flatFeePayPeriod,
  loans,
  standardPayPeriod,
  unsupportedPayPeriod,
} from './payPeriods';

export interface Scenario {
  id: string;
  label: string;
  caption: string;
  payPeriod: PayPeriod;
  paymentType: PaymentType | null;
  values?: Partial<PaymentFormValues>;
  step?: 'form' | 'success';
  forceFailure?: boolean;
  unavailable?: 'missing_pay_period' | 'unsupported_model' | null;
}

const standardPaymentValues: Partial<PaymentFormValues> = {
  loanId: loans[0].id,
  grossCommission: '9,180.00',
  loSplit: '70',
};

export const scenarios: Scenario[] = [
  {
    id: 'payment_standard',
    label: 'Payment · Standard',
    caption: 'Loan & Commission plus Split Details',
    payPeriod: standardPayPeriod,
    paymentType: 'payment',
    values: standardPaymentValues,
  },
  {
    id: 'expense',
    label: 'Expense',
    caption: 'No loan required',
    payPeriod: standardPayPeriod,
    paymentType: 'expense',
    values: {
      expenseAmount: '1,450.00',
      expenseCategory: 'Desk Rental',
      expenseDetail: 'August desk rental — Suite 210, Bellevue office',
      expenseDate: '2026-08-12',
    },
  },
  {
    id: 'success',
    label: 'Success',
    caption: 'Payment saved confirmation',
    payPeriod: standardPayPeriod,
    paymentType: 'payment',
    values: standardPaymentValues,
    step: 'success',
  },
  {
    id: 'empty',
    label: 'No type selected',
    caption: 'Progressive disclosure start',
    payPeriod: standardPayPeriod,
    paymentType: null,
  },
  {
    id: 'payment_flat_fee',
    label: 'Payment · Flat Fee',
    caption: 'Split Details hidden entirely',
    payPeriod: flatFeePayPeriod,
    paymentType: 'payment',
    values: {
      loanId: loans[1].id,
      grossCommission: '6,420.00',
      flatFee: '1,250.00',
      processingFee: '895.00',
    },
  },
  {
    id: 'error',
    label: 'Save error',
    caption: 'Locked pay period',
    payPeriod: standardPayPeriod,
    paymentType: 'payment',
    values: standardPaymentValues,
    forceFailure: true,
  },
  {
    id: 'unsupported_model',
    label: 'Unsupported model',
    caption: 'Blocked entry state',
    payPeriod: unsupportedPayPeriod,
    paymentType: null,
    unavailable: 'unsupported_model',
  },
  {
    id: 'missing_pay_period',
    label: 'Missing pay period',
    caption: 'Blocked entry state',
    payPeriod: standardPayPeriod,
    paymentType: null,
    unavailable: 'missing_pay_period',
  },
];
